var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "map-timebar", style: _vm.css_props }, [
    _c("div", { ref: "progress", staticClass: "progress" }, [
      _c("div", { staticClass: "label" }, [
        _c("div", { staticClass: "text-container" }, [
          _c("div", {
            staticClass: "circle",
            class: { active: !_vm.hover_index }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "text" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.date_tag_list[_vm.hover_index || _vm.play_index]) +
                "\n                "
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "text" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.time_tag_list[_vm.hover_index || _vm.play_index]) +
                "\n                "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "center-time",
          style: {
            left: _vm.center_time_left + "px",
            width: _vm.center_time_block_width + "px"
          }
        },
        [
          _c("span", [
            _vm._v(
              "\n                " +
                _vm._s(_vm.center_time_text) +
                "\n            "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block" },
        _vm._l(_vm.list, function(time, key) {
          return _c("div", { key: key, staticClass: "block-item" }, [
            _vm.extreme_time_tags.includes(time) ||
            time === _vm.latest_complete_data_timestamp
              ? _c(
                  "span",
                  {
                    staticClass: "block-item__text",
                    class: {
                      "block-item__text--latest-complete":
                        time === _vm.latest_complete_data_timestamp
                    }
                  },
                  [
                    !_vm.is_mobile_width && _vm.extreme_time_tags.includes(time)
                      ? [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.date_tag_list[key]) +
                              " \n                    "
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.time_tag_list[key]) +
                        "\n                "
                    )
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c("span", {
              staticClass: "block-item__node",
              class: {
                active: key === _vm.play_index,
                hover: key === _vm.hover_index,
                "block-item__node--latest-complete":
                  time === _vm.latest_complete_data_timestamp
              },
              on: {
                click: function($event) {
                  _vm.play_index = key
                },
                mouseover: function($event) {
                  _vm.hover_index = key
                },
                mouseout: function($event) {
                  _vm.hover_index = null
                }
              }
            })
          ])
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ctrl" },
      [
        _c("QpeTooltip", {
          attrs: { tooltip_position: "top" },
          scopedSlots: _vm._u([
            {
              key: "hovered_item",
              fn: function() {
                return [
                  _c(
                    "v-icon",
                    {
                      staticClass: "ctrl__icon",
                      attrs: { color: "white" },
                      on: { click: _vm.rewind_time_unit }
                    },
                    [
                      _vm._v(
                        "\n                    mdi-rewind\n                "
                      )
                    ]
                  )
                ]
              },
              proxy: true
            },
            {
              key: "tooltip_content",
              fn: function() {
                return [
                  _c("span", [_vm._v(_vm._s(_vm.$t("__timeline.rewind")))])
                ]
              },
              proxy: true
            }
          ])
        }),
        _vm._v(" "),
        _c("QpeTooltip", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.is_playing,
              expression: "!is_playing"
            }
          ],
          attrs: { tooltip_position: "top" },
          scopedSlots: _vm._u([
            {
              key: "hovered_item",
              fn: function() {
                return [
                  _c(
                    "v-icon",
                    {
                      staticClass: "ctrl__icon",
                      attrs: { color: "white" },
                      on: {
                        click: function($event) {
                          _vm.is_playing = !_vm.is_playing
                        }
                      }
                    },
                    [_vm._v("\n                    mdi-play\n                ")]
                  )
                ]
              },
              proxy: true
            },
            {
              key: "tooltip_content",
              fn: function() {
                return [_c("span", [_vm._v(_vm._s(_vm.$t("__timeline.play")))])]
              },
              proxy: true
            }
          ])
        }),
        _vm._v(" "),
        _c("QpeTooltip", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.is_playing,
              expression: "is_playing"
            }
          ],
          attrs: { tooltip_position: "top" },
          scopedSlots: _vm._u([
            {
              key: "hovered_item",
              fn: function() {
                return [
                  _c(
                    "v-icon",
                    {
                      staticClass: "ctrl__icon",
                      attrs: { color: "white" },
                      on: {
                        click: function($event) {
                          _vm.is_playing = !_vm.is_playing
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    mdi-pause\n                "
                      )
                    ]
                  )
                ]
              },
              proxy: true
            },
            {
              key: "tooltip_content",
              fn: function() {
                return [
                  _c("span", [_vm._v(_vm._s(_vm.$t("__timeline.pause")))])
                ]
              },
              proxy: true
            }
          ])
        }),
        _vm._v(" "),
        _c("QpeTooltip", {
          attrs: { tooltip_position: "top" },
          scopedSlots: _vm._u([
            {
              key: "hovered_item",
              fn: function() {
                return [
                  _c(
                    "v-icon",
                    {
                      staticClass: "ctrl__icon",
                      attrs: { color: "white" },
                      on: { click: _vm.forward_time_unit }
                    },
                    [
                      _vm._v(
                        "\n                    mdi-fast-forward\n                "
                      )
                    ]
                  )
                ]
              },
              proxy: true
            },
            {
              key: "tooltip_content",
              fn: function() {
                return [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("__timeline.fast_forward")))
                  ])
                ]
              },
              proxy: true
            }
          ])
        }),
        _vm._v(" "),
        _vm.auto_update_btn_activate ? _c("AutoUpdatePanel") : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }